"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateFileName = void 0;
const generateFileName = params => {
  const {
    prefix = 'download',
    ext = 'png'
  } = params ?? {};
  const now = new Date();
  const date = now.toISOString().split('T')[0];
  const time = now.toTimeString().slice(0, 8).replaceAll(':', '-');
  return `${prefix}-${date}_${time}.${ext}`;
};
exports.generateFileName = generateFileName;
